import { render } from "./ContactListItem.vue?vue&type=template&id=4b60aae8&ts=true"
import script from "./ContactListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactListItem.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/contact/components/ContactListItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b60aae8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b60aae8', __exports__)) {
    api.reload('4b60aae8', __exports__)
  }
  
  module.hot.accept("./ContactListItem.vue?vue&type=template&id=4b60aae8&ts=true", () => {
    api.rerender('4b60aae8', render)
  })

}


export default __exports__